module.exports = __webpack_public_path__ + "img/train-subway-tunnel.e34b13f7.svg";